<script lang="ts" setup generic="RowType extends { id: string }">
export type ColumnItemDescriptor = {
  key: string
  label?: string
  width?: string
}

defineProps<{
  columns: ColumnItemDescriptor[]
  data: RowType[]
  noHeaders?: boolean
  hover?: boolean
}>()

defineEmits<{
  (e: 'mouseoverRow', value: number): void
  (e: 'mouseleaveRow'): void
}>()
</script>

<template>
  <table class="w-full border-collapse">
    <thead
      v-if="!noHeaders"
      class="text-left"
    >
      <tr>
        <th
          v-for="column in columns"
          :key="column.key"
          class="border-b border-border-subtle px-1 py-1.5 text-sm-12px-default text-text-subtle"
        >
          {{ column.label }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(row, rowIndex) in data"
        :key="row.id"
        class="group/row"
        :class="{ 'hover:bg-background-transparent-hovered': hover }"
        @mouseover="$emit('mouseoverRow', rowIndex)"
        @mouseleave="$emit('mouseleaveRow')"
      >
        <td
          v-for="column in columns"
          :key="column.key"
          class="border-b border-border-subtle px-1 py-1.5 text-sm-12px-light text-text"
          :style="column.width ? `width:${column.width}` : undefined"
        >
          <slot
            :name="column.key"
            :row-index="rowIndex"
            :row="row"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>
